const promotionalBanner = () => {
    // Missing Covers Function
    function missingCoversClass() {
        const missingCover = document.querySelector('.missing-cover__bg');
        if (!missingCover) return;
        
        const missingCoverWidth = missingCover.offsetWidth;

        if (missingCoverWidth <= 124) {
            missingCover.classList.add('w124');
            missingCover.classList.remove('w154', 'w155');
        }
        if (missingCoverWidth <= 154) {
            missingCover.classList.add('w154');
            missingCover.classList.remove('w224', 'w300');
        }
        if (missingCoverWidth >= 155) {
            missingCover.classList.add('w155');
            missingCover.classList.remove('w124', 'w224', 'w300');
        }
        if (missingCoverWidth >= 220) {
            missingCover.classList.add('w224');
        }
        if (missingCoverWidth >= 300) {
            missingCover.classList.add('w300');
        }
    }

    // Promotional Banner functionality
    function initPromotionalBanner() {
        setTimeout(function () {
            const promoBanner = document.getElementById('promotional__banner');
            const footer = document.querySelector('.c-footer__btm');
            if (promoBanner) {
                promoBanner.classList.add('promotional__banner');
                promoBanner.classList.remove('promotional__banner--hidden');
                if (footer) {
                    footer.classList.add('promotional__banner--active');
                }
            }
        }, 2000);
    }

    // Hide banner function (make it globally available)
    window.hideBanner = function() {
        const promoBanner = document.getElementById('promotional__banner');
        if (promoBanner) {
            promoBanner.classList.remove('promotional__banner');
            promoBanner.classList.add('promotional__banner--hidden');
        }
    };

    // Initialize event listeners for banner interactions
    function initBannerEventListeners() {
        document.addEventListener('click', function(event) {
            if (event.target && event.target.getAttribute('data-action') === 'hide-banner') {
                event.preventDefault();
                window.hideBanner();
            }
        });
    }

    // Initialize on window load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            missingCoversClass();
            initPromotionalBanner();
            initBannerEventListeners();
        });
    } else {
        missingCoversClass();
        initPromotionalBanner();
        initBannerEventListeners();
    }

    // Trigger missing covers class on resize
    window.addEventListener('resize', function() {
        missingCoversClass();
    });
};

export default promotionalBanner;
